import React from 'react';

/**
 * قاب یکسان برای کلاژ لندینگ — padding متعادل، بدون فضای خالی اضافه.
 */
export default function LandingCollageCard({ children, glow }) {
  return (
    <div className="dash-card-surface relative overflow-hidden rounded-[1.5rem] border border-hairline/35 p-2 shadow-saas ring-1 ring-signal/[0.06] sm:rounded-[1.75rem] sm:p-2.5 md:rounded-[2rem] md:p-3">
      {glow}
      {children}
    </div>
  );
}
